import { UIElement } from './index';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIObserverElement
 * @classdesc Represents a class for observing DOM mutations.
 */
export abstract class UIObserverElement extends UIElement {
    observer!: MutationObserver;

    /**
     * Observed mutation options used to configure the MutationObserver.
     * @returns {MutationObserverInit}
     */
    abstract getObservedMutationOptions(): MutationObserverInit;

    /**
     * Callback for DOM mutations. Runs whenever the observed element is mutated according to options defined in getObservedMutationOptions.
     * @param {Array<MutationRecord>} mutations
     */
    abstract handleMutations(mutations: Array<MutationRecord>): void;

    /**
     * @inheritDoc
     */
    hydrate(): void {
        this.observer = new MutationObserver(this.handleMutations.bind(this));
        this.observer.observe(this, this.getObservedMutationOptions());
    }

    /**
     * @inheritDoc
     */
    disconnect(): void {
        this.observer.disconnect();
    }

    /**
     * @inheritDoc
     */
    reconnect(): void {
        this.observer.observe(this, this.getObservedMutationOptions());
    }
}
